/* export
  - menuIdRouteMappings
  - menuIdNameMappingsFromBundle
*/

import { CountryCode } from 'libphonenumber-js';

export * from 'sce-core';
// #TODO-LIBRARY constants->menuIdRouteMappings Used in 13 places 13 files in WMS /src/app.. should be re-referenced from library directly

export const alpha2CountryCode = new Map<string, CountryCode>([
  ['SGP', 'SG'],
  ['IND', 'IN'],
  ['CHN', 'CN'],
  ['MYS', 'MY'],
  ['THA', 'TH'],
  ['VNM', 'VN'],
  ['IDN', 'ID'],
  ['PHL', 'PH'],
  ['KOR', 'KR'],
  ['TWN', 'TW'],
  ['ZAF', 'ZA'],
  ['SAU', 'SA'],
]);
